import { FC, useEffect, useState } from 'react'
import { List, Card, Typography } from 'antd'
import { useParams, useNavigate } from 'react-router-dom'
import { relayStore } from '../../store/relay'
import { RNRelay, RNRelayType } from '../../helpers/routeNames'
import { CharacteristicCard } from '../../components/CharacteristicCard'
import { SearchInput } from '../../components/SearchInput'
import { PageBreadcrumb } from '../../components/PageBreadcrumb'

const { Title } = Typography

export const RelayTypeOne: FC = () => {
	const { relayTypeId } = useParams<{ relayTypeId: string }>()
	const { relayTypes, fetchRelaysByType } = relayStore()
	const navigate = useNavigate()
	const [, setFilteredRelays] = useState<any[]>([])

	useEffect(() => {
		if (relayTypeId) {
			fetchRelaysByType(relayTypeId)
		}
	}, [relayTypeId, fetchRelaysByType])

	const relayType = relayTypes.find((rt) => rt.id === relayTypeId)

	useEffect(() => {
		if (relayType?.relays) {
			setFilteredRelays(relayType.relays)
		}
	}, [relayType?.relays])

	if (!relayType) {
		return <div>Тип реле не найден</div>
	}

	return (
		<div>
			<PageBreadcrumb
				items={[
					{ label: 'Типы реле', path: RNRelayType },
					{ label: relayType.name }
				]}
			/>
			<header
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center'
				}}>
				<Title level={2}>{relayType.name}</Title>
			</header>
			<main>
				<CharacteristicCard
					title="Информация о типе реле"
					data={[
						{
							label: 'Дата создания',
							value: new Date(
								relayType.createdAt
							).toLocaleString('ru')
						},
						{
							label: 'Реле',
							value: relayType.relays.length
						},
						{
							label: 'Механика',
							value: relayType.mechanics.length
						},
						{
							label: 'Электрика',
							value: relayType.electrics.length
						}
					]}
				/>
				<Title level={3}>Реле</Title>
				<SearchInput
					data={relayType.relays}
					searchFields={['name']}
					onSearch={setFilteredRelays}
					placeholder="Поиск по названию реле">
					{(data) => (
						<List
							grid={{
								gutter: 16,
								column: 4,
								xs: 1,
								sm: 2,
								md: 3
							}}
							dataSource={data}
							renderItem={(relay) => (
								<List.Item>
									<Card
										title={relay.name}
										onClick={() =>
											navigate(
												RNRelay +
													'/' +
													relay.id
											)
										}
										hoverable>
										<p>
											Срок службы:{' '}
											{relay.expiration}
										</p>
										<p>
											Дата создания:{' '}
											{new Date(
												relay.createdAt
											).toLocaleString('ru')}
										</p>
									</Card>
								</List.Item>
							)}
						/>
					)}
				</SearchInput>
			</main>
		</div>
	)
}
